var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 36.6673H24.9997C33.333 36.6673 36.6663 33.334 36.6663 25.0007V15.0007C36.6663 6.66732 33.333 3.33398 24.9997 3.33398H14.9997C6.66634 3.33398 3.33301 6.66732 3.33301 15.0007V25.0007C3.33301 33.334 6.66634 36.6673 14.9997 36.6673Z",
    stroke: "#121212",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.833 30.8327C27.6663 30.8327 29.1663 29.3327 29.1663 27.4993V12.4993C29.1663 10.666 27.6663 9.16602 25.833 9.16602C23.9997 9.16602 22.4997 10.666 22.4997 12.4993V27.4993C22.4997 28.3834 22.8509 29.2312 23.476 29.8564C24.1011 30.4815 24.949 30.8327 25.833 30.8327ZM14.1663 30.8327C15.9997 30.8327 17.4997 29.3327 17.4997 27.4993V21.666C17.4997 19.8327 15.9997 18.3327 14.1663 18.3327C12.333 18.3327 10.833 19.8327 10.833 21.666V27.4993C10.833 28.3834 11.1842 29.2312 11.8093 29.8564C12.4344 30.4815 13.2823 30.8327 14.1663 30.8327Z",
    stroke: "#121212",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.64fd83aadc0edacb0f7ff3ac353588f3.svg";
export { ForwardRef as ReactComponent };